const Description = ({ content }) => {
	return (
		<div className="pdf-description-container d-flex flex-column gap-2 align-items-start text-white" style={{ padding: '0.2rem' }}>
			<div style={{ fontSize: '2rem', fontWeight: '900' }}>{content?.title}</div>
			<div className="text-white about-text-section" dangerouslySetInnerHTML={{ __html: content?.about || '' }} style={{ fontSize: '0.875rem' }}></div>
			<div style={{ fontSize: '1rem', fontWeight: '600' }}>{content?.instructor}</div>
		</div>
	);
};

export default Description;
